require('normalize.css');

require('./globals/scss/styles.scss');

// ====================//
// Imports and Exports //
// ====================//

// Base Elements & Components
// -------------
// - JavaScript classes for use with components and base-elements.
// - The following statements import classes from actual locations to
//   be consumed from this file instead of their actual locations.
export * from './globals/js/components';

export { default as settings } from './globals/js/settings';